import { createPushLoggly, setLoggly as _setLoggly } from "@mozioinc/logging";
import { getEnvs } from "./env";
import { getWhiteLabel } from "./white-label";

const { VERCEL_ENV, MOZIO_PUBLIC_LOGGLY_TOKEN } = getEnvs();

export let pushLoggly: ReturnType<typeof createPushLoggly>;

export const setLoggly = () => {
  _setLoggly({
    env: VERCEL_ENV,
    token: MOZIO_PUBLIC_LOGGLY_TOKEN,
  });

  const { partnerRef } = getWhiteLabel();
  pushLoggly = createPushLoggly({
    appName: "parking",
    appVersion: APP_VERSION,
    env: VERCEL_ENV,
    partnerRef: partnerRef,
  });
};
